/**
 * Created by vladislav on 19.05.20.
 */

const FarmTool = {
    set: function (buildingId, questId, skipLast) {
        const farm = cleverapps.meta.getSelectedLocation();

        farm._earnKeys = farm.earnKeys;
        farm.earnKeys = function (key) {
            this.keys[key] = (this.keys[key] || 0) + 1;
        }.bind(farm);

        this.reset();

        while (!farm.isCompleted() && (farm.currentBuildingId !== buildingId || farm.getBuilding().currentQuestId !== questId)) {
            const currentBuilding = farm.getBuilding();
            const currentQuest = currentBuilding.getQuest();
            while (!currentQuest.isCompleted()) {
                const building = farm.findBuildingForActiveItem();
                cleverapps.user.incPhysicalLevel();
                building.levelUp();
            }

            const nextProgress = this.calcNextProgress(currentBuilding);
            if (skipLast && nextProgress.buildingId === buildingId && nextProgress.questId === questId) {
                break;
            } else {
                this.moveNext();
            }
        }

        delete farm.justCollectedDialogue;
        farm.save();
        cleverapps.user.save();

        farm.earnKeys = farm._earnKeys;
        delete farm._earnKeys;
    },

    calcNextProgress: function (building) {
        if (building.currentQuestId + 1 === building.quests.length) {
            return {
                buildingId: building.id + 1,
                questId: 0
            };
        }

        return {
            buildingId: building.id,
            questId: building.currentQuestId + 1
        };
    },

    moveNext: function () {
        const farm = cleverapps.meta.getSelectedLocation();

        const items = farm.getBuilding().getQuest().items;
        items.forEach((key) => {
            farm.keys[key.name] -= key.amount;
        });

        if (!this.nextQuest(farm.getBuilding())) {
            farm.currentBuildingId++;
        }
    },

    nextQuest: function (building) {
        building.currentQuestId++;

        if (building.getQuest() === undefined) {
            building.open = true;
            return false;
        }

        return true;
    },

    reset: function () {
        const farm = cleverapps.meta.getSelectedLocation();
        farm.reset();

        cleverapps.user.currentPhysicalLevel.level = 0;
        cleverapps.user.currentPhysicalLevel.episode = 0;
    }
};